import React, { useEffect, useState } from "react";
import { FaSliders} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/Notificaciones.css";

const Notificaciones = () => {
  
  return (
    <>
        <Navbar />
        
        <main className="agenda">

        </main>
    </>
  );
};

export default Notificaciones;